/**
 * Selecao e memoria do microfone de entrada (M7.2).
 *
 * Bug original: `getUserMedia({ audio: true })` pega o device default/ultimo do browser (as vezes
 * o errado) e sem processamento. Aqui:
 *  - LEMBRA o ultimo `deviceId` escolhido (localStorage);
 *  - monta as constraints com `deviceId` + `echoCancellation/noiseSuppression/autoGainControl`
 *    (melhora a captacao de voz para transcricao).
 */

const STORAGE_KEY = 'td_mic_device_id';

/** deviceId preferido salvo, ou null se nunca escolhido. */
export function getPreferredMicId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

/** Salva o deviceId preferido (ou limpa se vazio = "padrao do sistema"). */
export function setPreferredMicId(deviceId: string | null): void {
  try {
    if (deviceId) localStorage.setItem(STORAGE_KEY, deviceId);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* localStorage indisponivel: segue sem memoria */
  }
}

/**
 * Constraints de audio para o getUserMedia (M7.2). Usa o device preferido (se houver) e liga o
 * processamento de voz. `deviceId: { ideal }` (nao `exact`) para nao falhar se o device sumiu —
 * cai no default graciosamente.
 */
export function micConstraints(): MediaStreamConstraints {
  const preferred = getPreferredMicId();
  const audio: MediaTrackConstraints = {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
    ...(preferred ? { deviceId: { ideal: preferred } } : {}),
  };
  return { audio };
}

/** Lista os microfones disponiveis (label preenchido so apos a 1a permissao concedida). */
export async function listMicrophones(): Promise<MediaDeviceInfo[]> {
  if (!navigator.mediaDevices?.enumerateDevices) {
    return [];
  }
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices.filter((d) => d.kind === 'audioinput');
  } catch {
    return [];
  }
}
